<template>
  <div>
    <button @click="enviarDatos">Enviar evento al servidor</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from '@axios'

export default {
  data() {
    return {
    };
  },
  mounted() {   
    let nombreUsuario = "Pablo " + Math.floor(Math.random() * 10) + 1;
    //this.$socket.emit('updateCorte', {usuario: nombreUsuario});

      /*axios
              .get("/taller/pruebas/socket")
              .then(response => {
                  return response.data;
              })
              .then(res => {
                console.log(res);
              });*/
  },
  watch: {  
    evento(newValue, oldValue){
        console.log("Evento desde el watch: " + newValue.data);
      },
      corteUpdate(newValue, oldValue){
        console.log("Corte Update watch: " + newValue);
      },
  },
  computed: {
    ...mapGetters('app', ['evento','corteUpdate']),
  },
  methods: {
    enviarDatos() {
      console.log('emit updateCorte');
      this.$socket.emit('tareacorte', { mensaje: 'Hola servidor' })
      //this.$socket.emit('tareacorte', { mensaje: 'Hola servidor' })
    }
  },
};

</script>